import SiteContentEditor from "@/project/jain_elibrary-admin/pages/content/SiteContentEditor";

/** Public home hero (title + subtitle HTML). Slug: `home-hero`. */
const HomeHero = () => (
  <SiteContentEditor slug="home-hero" heading="Home page hero" />
);

export default HomeHero;
